import {Component, Inject, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
    CourseRoster,
    GradePostStatus,
    Student,
    StudentGradeValidation,
    StudentGradeValidationError
} from '../../shared/interface/roster.interface';
import {RosterService} from '../../shared/roster.service';
import {GradeValidationService} from '../../shared/grade-validation.service';
import {
    GradePostCompleteStatus,
    GradeValidationStatus,
    GradeValidationStatusDetail,
    GradeValidationStatusDetailList
} from '../../shared/interface/grade-validation.interface';
import {DatePipe} from '@angular/common';
import {GradePostTransactionIdService} from '../../shared/services/grade-post-transaction-id.service';
import {catchError, timeout} from 'rxjs/operators';

@Component({
    selector: 'app-roster-grad-submit-status',
    templateUrl: './grade-submit-status-component.html',
    styleUrls: ['./grade-submit-status-component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class GradeSubmitStatusComponent implements OnInit, OnDestroy {
    private intervalTime: number = 3500;
    private gradePostStatusInterval: number = 5000;
    private postTimeOutKill: number = 60000;
    private done: boolean;

    constructor(
        public dialogRef: MatDialogRef<GradeSubmitStatusComponent>,
        public datePipe: DatePipe,
        public rosterService: RosterService,
        public gradeValidationService: GradeValidationService,
        public gradePostTransactionIdService: GradePostTransactionIdService,
        @Inject(MAT_DIALOG_DATA) public data: CourseRoster
    ) {
    }

    returnResultData: Array<String> = [];
    intervalPostGradeStatus: number;
    intervalPostStatusInProgress: number;
    validationStatus: GradeValidationStatus;
    gradePostStatus: GradePostStatus;
    validationStatusInProgress: boolean = false;
    gradePostStatusInProgress: boolean = false;
    hideValidationStatus: boolean = false;

    //local variables that is needed
    ngOnInit(): void {
        this.restValidationStatus();

        this.getValidationStatus();
        this.submitGrade();
    }

    clearInterval(): void {
        if (this.intervalPostGradeStatus) {
            clearInterval(this.intervalPostGradeStatus);
        }
        if (this.intervalPostStatusInProgress) {
            clearInterval(this.intervalPostStatusInProgress);
        }
        this.restValidationStatus();
    }

    ngOnDestroy(): void {
        this.clearInterval();
    }

    restValidationStatus() {
        this.validationStatus = {
            transactionId: this.gradePostTransactionIdService.getNewTransactionId(),
            totalCount: 0,
            currentCount: 0
        };
        this.validationStatusInProgress = false;
        this.gradePostStatusInProgress = false;
    }

    getValidationStatus() {
        // return if validation status is in progress
        if (this.validationStatusInProgress) {
            return;
        }
        //validation status is not run set in progress to true
        this.hideValidationStatus = false;
        this.validationStatusInProgress = true;
        this.gradeValidationService
            .getByRosterPostStatus(this.validationStatus.transactionId)
            .subscribe((response: GradeValidationStatus) => {
                console.log(response);
                this.validationStatus = response;
                // complete has response set response to false
                this.validationStatusInProgress = false;
            });
    }

    getPostGradeStatus() {
        if (this.gradePostStatusInProgress) {
            return;
        }
        this.hideValidationStatus = true;
        this.gradePostStatusInProgress = true;
        console.log(this.rosterService.currentRoster);
        console.log(this.validationStatus.transactionId);
        this.rosterService
            .getPostStatus(this.validationStatus.transactionId, this.rosterService.currentRoster?.id)
            .subscribe((response: GradePostStatus) => {
                this.gradePostStatusInProgress = false;
                this.gradePostStatus = response;
                if (response.complete) {
                    this.returnResultData.push('Grades have been submitted.');
                    this.onClose();
                }
            });
    }

    submitGrade() {
        let rosterService: RosterService;

        this.intervalPostGradeStatus = setInterval(() => {
            this.getValidationStatus();
        }, this.intervalTime);

        this.rosterService.post(this.rosterService.currentRoster, this.validationStatus.transactionId)
            .pipe(timeout(this.postTimeOutKill))
            .subscribe(
                (response: StudentGradeValidationError) => {
                    // only if we cannot pos
                    if (response.gradePostComplete.toUpperCase() === 'N') {
                        switch (response.errorCode.toUpperCase()) {
                            case 'N': {
                                this.returnResultData.push(
                                    'Unable to submit grade.  Banner error please see validation log.'
                                );
                                break;
                            }
                            case 'S': {
                                this.returnResultData.push('Unable to submit grade. \nNo grade change.');
                                break;
                            }

                            default: {
                                this.returnResultData.push('Unable to submit grade.');
                                break;
                            }
                        }

                        response?.rows.forEach(function (value: StudentGradeValidation) {
                            //find the student record and update the status code and message
                            rosterService.currentRoster.roster.find((item: Student) => {
                                if (item.studentId == value.studentId) {
                                    item.gradeValidationCode = value.status;
                                    item.gradeValidationDescription = value.description;
                                }
                            });
                        });
                    } else {
                        this.returnResultData.push('Grades have been submitted.');
                    }

                    this.onClose();
                },
                (error) => {
                    this.intervalPostStatusInProgress = setInterval(() => {
                        this.getPostGradeStatus();
                    }, this.gradePostStatusInterval);
                }
            );
    }

    getDetailData() {
        let rosterService: RosterService;

        this.gradeValidationService
            .getPostStatusDetail(this.validationStatus.transactionId)
            .subscribe((response: GradeValidationStatusDetailList) => {
                response?.list?.forEach(function (value: GradeValidationStatusDetail) {
                    rosterService.currentRoster.roster.find((item: Student) => {
                        if (item.studentId == value.studentId) {
                            item.gradeValidationCode = value.gradeValidationCode;
                            item.gradeValidationDescription = value.gradeValidationDescription;
                        }
                    });
                });

                this.gradeValidationService
                    .getPostCompleteDetail(this.validationStatus.transactionId)
                    .subscribe((response: GradePostCompleteStatus) => {
                        if (response.gradePostComplete.toUpperCase() === 'N') {
                            switch (response.errorCode.toUpperCase()) {
                                case 'N': {
                                    this.returnResultData.push(
                                        'Unable to submit grade.  Banner error please see validation log.'
                                    );
                                    break;
                                }
                                case 'S': {
                                    this.returnResultData.push('Unable to submit grade. \nNo grade change.');
                                    break;
                                }

                                default: {
                                    this.returnResultData.push('Unable to submit grade.');
                                    break;
                                }
                            }
                        } else {
                            this.returnResultData.push('Grades have been submitted.');
                        }
                    });

                this.onClose();
            });
    }

    gradePostComplete() {
        this.getDetailData();
    }

    onClose() {
        this.clearInterval();
        this.dialogRef.close(this.returnResultData);
    }
}
